<template>
  <MessagePopup :visible="$store.getters.showNotificationsRequestPopup">
    <template v-slot:content>
      Möchtest du Push-Benachrichtigungen für z.B. Preisänderungen erhalten?
    </template>
    <template v-slot:actions>
      <button class="button button--secondary" @click="disableNotifications()">
        Nein
      </button>
      <button class="button button--primary" @click="enableNotifications()">
        Ja
      </button>
    </template>
  </MessagePopup>
</template>

<script>
  import MessagePopup from '@/components/MessagePopup'

  export default {
    name: 'notifications-request-popup',
    components: {
      MessagePopup,
    },
    methods: {
      enableNotifications() {
        this.$store.dispatch('requestNotificationsPermission')
        this.$store.dispatch('subscribeToPushApi')
        this.$store.commit('showNotificationsRequestPopup', false)
      },
      disableNotifications() {
        this.$store.dispatch('disableNotifications')
        this.$store.dispatch('unsubscribeFromPushApi')
        this.$store.commit('showNotificationsRequestPopup', false)
      },
    },
  }
</script>

<style lang="scss"></style>
